import React, { FC }          from 'react';
import {
  CommentForm,
  CommentsList,
}                             from '@components/index';
import {
  IComment,
  IDocument,
  ICommentValues,
}                             from '@typings/comments';
import { ICreditUnion }       from '@typings/accountManagement';
import { AccountPageWrapper } from '@modules/accountManagement/components/AccountPageWrapper';

interface IProps {
  push              : (path: string) => void;
  comments          : IComment[];
  accountData       : ICreditUnion;
  fetchDocument     : (document: IDocument) => Promise<void>;
  handleSaveComment : (comment: ICommentValues) => Promise<void>;
}

export const CommentsPage: FC<IProps> = ({
  push,
  comments,
  accountData,
  fetchDocument,
  handleSaveComment,
}) => (
  <AccountPageWrapper
    push   = {push}
    cuInfo = {accountData}
  >
    <CommentForm
      accountNumber     = {accountData?.cuid}
      handleSaveComment = {handleSaveComment}
    />

    <CommentsList
      comments      = {comments}
      fetchDocument = {fetchDocument}
    />
  </AccountPageWrapper>
);
